import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import PopupPortal from 'apps/auth/components/common/Popup/PopupPortal';
import { Text } from 'apps/auth/components/common/Text/Text';
import FieldLongTitlePopup from 'apps/auth/components/form-multi/FieldLongTitlePopup';
import {
    CATEGORY_TRANSFER_FROM_APPLE_PAY,
    CATEGORY_TRANSFER_FROM_APPLE_PAY_SV,
    CATEGORY_TRANSFER_FROM_BANK_ACCOUNT,
    CATEGORY_TRANSFER_FROM_BONUS,
    CATEGORY_TRANSFER_FROM_GLOBAL_ACCOUNT,
    CATEGORY_TRANSFER_FROM_GOOGLE_PAY,
    CATEGORY_TRANSFER_FROM_GOOGLE_PAY_SV,
    STATUS_OK,
} from 'apps/auth/constants/Constants';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import { getStatusIcon, getTableTextColor, getTextColorFromStatus } from 'apps/auth/helpers/historyUtils';
import { resolveArguments, toLowerCase } from 'apps/auth/helpers/utils';
import { useLanguage } from 'apps/auth/hooks/selectors';

import CheckTableRow from './units/CheckTableRow';

const BillCheque = (props) => {
    const { lang } = useLanguage();
    const popupRef = useRef(null);
    const cheque = props.cheque;

    const isUsaUser = () => {
        return props.userCountryId === USA;
    };
    const getPopupComponent = () => {
        return <FieldLongTitlePopup info={props.exchangeRatePopupUsaCommentInfo} popupRef={popupRef} />;
    };

    const getStatusText = (chequeForText) => {
        let statusText = props.chequeStatusInProgress;
        if (chequeForText.status < STATUS_OK && chequeForText.fromBankAccountStatusBean) {
            statusText = props.chequeAccountStatusInProgress;
        } else if (chequeForText.status === STATUS_OK) {
            statusText = props.chequeStatusSuccess;
        } else if (chequeForText.status > STATUS_OK && (chequeForText.cancellingProcess || chequeForText.errorCode === 69)) {
            statusText = props.chequeStatusCanceled;
        } else if (chequeForText.status > STATUS_OK) {
            statusText = props.chequeStatusError;
        }
        return statusText;
    };

    const getAvatar = (chequeForAvatar) => {
        if (chequeForAvatar.avatar) {
            return chequeForAvatar.avatar;
        } else {
            return null;
        }
    };

    const getLetter = (chequeForAvatar) => {
        if (chequeForAvatar.avatar) {
            return null;
        } else if (chequeForAvatar.firstLetter) {
            return chequeForAvatar.firstLetter;
        } else {
            return ':)';
        }
    };

    const getAmount = (chequeForAmount) => {
        const fromCurrency =
            chequeForAmount.amountFromCurrency && typeof chequeForAmount.amountFromCurrency === 'string'
                ? chequeForAmount.amountFromCurrency.toLowerCase()
                : '';
        const toCurrency =
            chequeForAmount.amountToCurrency && typeof chequeForAmount.amountToCurrency === 'string' ? chequeForAmount.amountToCurrency.toLowerCase() : '';
        return (
            <>
                <Text size="header" color={getTextColorFromStatus(cheque)} ellipsis lineThrough={cheque.status > STATUS_OK}>
                    {`${chequeForAmount.amountFrom} `}
                    <Text size="header" smallCaps color={getTextColorFromStatus(cheque)}>
                        {fromCurrency}
                    </Text>
                </Text>
                <Text size="header" color={getTextColorFromStatus(cheque)}>
                    {' → '}
                </Text>
                <Text size="header" color={getTextColorFromStatus(cheque)} ellipsis lineThrough={cheque.status > STATUS_OK}>
                    {`${chequeForAmount.amountTo} `}
                    <Text size="header" smallCaps color={getTextColorFromStatus(cheque)}>
                        {toCurrency}
                    </Text>
                </Text>
            </>
        );
    };

    const getFromProviderTitle = (providerId, accountFrom) => {
        if (providerId === CATEGORY_TRANSFER_FROM_GOOGLE_PAY || providerId === CATEGORY_TRANSFER_FROM_GOOGLE_PAY_SV) {
            return resolveArguments(props.chequeFromGoogle, accountFrom);
        } else if (providerId === CATEGORY_TRANSFER_FROM_APPLE_PAY || providerId === CATEGORY_TRANSFER_FROM_APPLE_PAY_SV) {
            return resolveArguments(props.chequeFromApple, accountFrom);
        } else if (providerId === CATEGORY_TRANSFER_FROM_BANK_ACCOUNT) {
            return resolveArguments(props.chequeFromBankAccount, accountFrom);
        } else if (providerId === CATEGORY_TRANSFER_FROM_GLOBAL_ACCOUNT) {
            return resolveArguments(props.chequeFromGlobalAccount, accountFrom);
        } else if (providerId === CATEGORY_TRANSFER_FROM_BONUS) {
            return resolveArguments(props.chequeFromBonus, accountFrom);
        } else {
            return resolveArguments(props.chequeFromCard, accountFrom);
        }
    };

    return (
        <>
            {isUsaUser() && (
                <Text variant="div" size="secondary" indent="adaptive-24-32">
                    {props.chequeUsaNotReceipt}
                </Text>
            )}
            <Row indent="adaptive-16-24">
                <DiskBadge
                    src={getAvatar(cheque)}
                    diskText={getLetter(cheque)}
                    diskSize="large"
                    isDisabled={cheque.status > STATUS_OK}
                    flagName={toLowerCase(cheque.toBankCountryCode)}
                />
            </Row>
            <Text variant="div" color={getTextColorFromStatus(cheque)} indent="4px" ellipsis>
                {resolveArguments(props.chequePayRequestBlockTitle, cheque.billIssuer)}
            </Text>
            <Row indent="64px">
                <Row indent="adaptive-32-48">
                    <Row indent="adaptive-8-16">{getAmount(cheque)}</Row>
                    {cheque.comment && (
                        <Text variant="div" color={getTextColorFromStatus(cheque)}>
                            {cheque.comment}
                        </Text>
                    )}
                </Row>
                <Row flex align="center" indent="adaptive-32-48">
                    <Icon name={getStatusIcon(cheque.status)} rightIndent="16px" />
                    {getStatusText(cheque)}
                </Row>
                {cheque.status > STATUS_OK && <Text variant="div">{cheque.errorMessage}</Text>}
            </Row>

            {cheque.waitingVerification && (
                <>
                    <Separator marginBottom="16px" />
                    <Panel type="reactLink" isHoverable negativeMargin to={`/auth/card/confirm/${props.unconfirmedLinkId}/preview`}>
                        <DiskBadgeWrapper>
                            <DiskBadge variant="primary" iconName="alert" />
                        </DiskBadgeWrapper>
                        <Text color="primary">{props.chequeVerifyButton}</Text>
                    </Panel>
                </>
            )}
            <Separator marginTop="16px" />
            <TableContainer>
                <CheckTableRow title={props.chequeDate} cheque={cheque}>
                    {props.getFormattedChequeDate(props.userCountryId, cheque?.date, lang)}
                </CheckTableRow>
                <CheckTableRow title={props.chequeFee} cheque={cheque}>
                    {cheque.commission}
                </CheckTableRow>
                {cheque.exchangeRate && (
                    <CheckTableRow title={isUsaUser() ? props.chequeUsaFxRate : props.chequeFxRate} cheque={cheque}>
                        <Row flex align="center">
                            {cheque.exchangeRate}
                            {isUsaUser() && (
                                <DiskButton
                                    size="small"
                                    iconName="info-rounded"
                                    iconColor={getTableTextColor(cheque)}
                                    type="button"
                                    raised={false}
                                    onClick={() => popupRef.current?.open()}
                                />
                            )}
                        </Row>
                    </CheckTableRow>
                )}
                {cheque.promoCode && (
                    <CheckTableRow title={props.chequePromocodeFaild} cheque={cheque}>
                        {cheque.promoCode}
                    </CheckTableRow>
                )}
            </TableContainer>
            <Separator />
            <TableContainer>
                <CheckTableRow title={props.chequeFromCardHeader} cheque={cheque}>
                    {getFromProviderTitle(cheque.providerFromCategory, cheque.accountFrom)}
                </CheckTableRow>
                <CheckTableRow title={props.chequeOperationNumber} cheque={cheque}>
                    {cheque.paymentId}
                </CheckTableRow>
            </TableContainer>
            <PopupNew ref={popupRef} getPopupComponent={getPopupComponent} as={PopupPortal} />
        </>
    );
};

const mapStateToProps = (state) => ({
    serviceProvider: state.messages.pageMessages.serviceProvider,
    serviceProviderName: state.messages.pageMessages.serviceProviderName,
    cheque: state.history.cheque.cheque,
    chequePayRequestBlockTitle: state.messages.pageMessages.chequePayRequestBlockTitle,
    chequeStatusInProgress: state.messages.pageMessages.chequeStatusInProgress,
    chequeAccountStatusInProgress: state.messages.pageMessages.chequeAccountStatusInProgress,
    chequeStatusSuccess: state.messages.pageMessages.chequeStatusSuccess,
    chequeStatusCanceled: state.messages.pageMessages.chequeStatusCanceled,
    chequeStatusError: state.messages.pageMessages.chequeStatusError,
    chequeVerifyButton: state.messages.pageMessages.chequeVerifyButton,
    chequePromocodeFaild: state.messages.pageMessages.chequePromocodeFaild,
    chequeDate: state.messages.pageMessages.chequeDate,
    chequeFee: state.messages.pageMessages.chequeFee,
    chequeFxRate: state.messages.pageMessages.chequeFxRate,
    chequeUsaFxRate: state.messages.pageMessages.chequeUsaFxRate,
    chequeFromCardHeader: state.messages.pageMessages.chequeFromCardHeader,
    chequeFromGoogle: state.messages.pageMessages.chequeFromGoogle,
    chequeFromApple: state.messages.pageMessages.chequeFromApple,
    chequeFromBankAccount: state.messages.pageMessages.chequeFromBankAccount,
    chequeFromGlobalAccount: state.messages.pageMessages.chequeFromGlobalAccount,
    chequeFromBonus: state.messages.pageMessages.chequeFromBonus,
    chequeFromCard: state.messages.pageMessages.chequeFromCard,
    chequeOperationNumber: state.messages.pageMessages.chequeOperationNumber,
    exchangeRatePopupUsaCommentInfo: state.messages.pageMessages.exchangeRatePopupUsaCommentInfo,
    unconfirmedLinkId: state.history.cheque.unconfirmedLinkId,
    userCountryId: state.auth.countryId,
    chequeUsaNotReceipt: state.messages.pageMessages.chequeUsaNotReceipt,
});

export default connect(mapStateToProps)(BillCheque);
